export const FORM_NAME = 'createAccount'

export const PASSWORD_PROPERTY = 'password'
export const CONFIRM_PASSWORD_PROPERTY = 'confirmPass'
export const EMAIL_PROPERTY = 'login'
export const KEEP_IN_CONTACT_PROPERTY = 'emailMe'
export const KEEP_IN_CONTACT_PROPERTY_NEW = 'promonOffers'
export const TERMS_AGREEMENT_PROPERTY = 'termsConditions'
export const HIDDEN_PROPERTY = 'hiddenField'
export const FIRST_NAME_PROPERTY = 'firstName'
export const LAST_NAME_PROPERTY = 'lastName'
export const PHONE_NUMBER_PROPERTY = 'primaryPhone'

// messages
export const EMAIL_EMPTY = 'Please enter your email address.'
export const EMAIL_INVALID = 'Please enter valid email address.'
export const PASSWORD_EMPTY = 'Please enter your password.'
export const TERMS_AGREEMENT_UNSELECTED = 'Please accept the Big O Tires Privacy Policy.'
export const FIRST_NAME_EMPTY = 'Please enter your first name.'
export const LAST_NAME_EMPTY = 'Please enter your last name.'
export const PHONE_NUMBER_EMPTY = 'Please enter your phone number.'
export const INVALID_FIRST_NAME = 'Your First Name may only consist of up to 20 characters. Please try again.'
export const INVALID_LAST_NAME = 'Your Last Name may only consist of up to 20 characters. Please try again.'
export const ALREADY_REGISTERED_EMAIL_ERROR_MESSAGE = 'The email address you entered is already registered. Please enter a different email address.'

// form field hint ids
export const EMAIL_HINT_ID = 'email-input-notes'

// reCAPTCHA
export const RECAPTCHA_MESSAGE = 'Please confirm you are not a robot.'
